(function () {
  const TZ = 'Australia/Melbourne';
  const WEEKDAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  const DEFAULT_PROXY = 'https://book.fusionmirror.com/webhook';
  // Native <dialog> already owns the top layer. Bitwarden’s inline menu also
  // uses it; competing for it trips “interfering with the Bitwarden experience”.
  const PM_IGNORE =
    ' autocomplete="off" data-bwignore="true" data-1p-ignore="true" data-lpignore="true" data-form-type="other"';

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function melbourneDate(value) {
    return new Intl.DateTimeFormat('en-CA', {
      timeZone: TZ,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).format(value instanceof Date ? value : new Date(value));
  }

  function formatDayHeading(isoDate) {
    const date = parseIsoDate(isoDate);
    return new Intl.DateTimeFormat('en-AU', {
      timeZone: TZ,
      weekday: 'short',
      day: 'numeric',
      month: 'short'
    }).format(date);
  }

  function formatTime(iso) {
    return new Intl.DateTimeFormat('en-AU', {
      timeZone: TZ,
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    }).format(new Date(iso));
  }

  function formatWhen(iso) {
    return new Intl.DateTimeFormat('en-AU', {
      timeZone: TZ,
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    }).format(new Date(iso));
  }

  function parseIsoDate(isoDate) {
    const parts = String(isoDate).split('-').map(Number);
    return new Date(parts[0], parts[1] - 1, parts[2], 12, 0, 0);
  }

  function monthLabel(year, month) {
    return new Intl.DateTimeFormat('en-AU', {
      month: 'long',
      year: 'numeric'
    }).format(new Date(year, month, 1));
  }

  function daysInMonth(year, month) {
    return new Date(year, month + 1, 0).getDate();
  }

  function mondayIndex(year, month) {
    const weekday = new Date(year, month, 1).getDay();
    return (weekday + 6) % 7;
  }

  function toCalLink(url) {
    if (!url) return '';
    try {
      return new URL(url, window.location.origin).pathname.replace(/^\/+|\/+$/g, '');
    } catch (err) {
      return String(url).replace(/^https?:\/\/[^/]+\//, '').replace(/^\/+|\/+$/g, '');
    }
  }

  function splitCalLink(calLink) {
    const parts = String(calLink || '').split('/').filter(Boolean);
    return {
      username: parts[0] || 'trent-borchard-up9g45',
      eventTypeSlug: parts[1] || '30min'
    };
  }

  function pad2(n) {
    return String(n).padStart(2, '0');
  }

  function monthRange(year, month) {
    const last = daysInMonth(year, month);
    return {
      start: year + '-' + pad2(month + 1) + '-01',
      end: year + '-' + pad2(month + 1) + '-' + pad2(last)
    };
  }

  function uniqueIsoStarts(rawDays) {
    const days = {};
    Object.keys(rawDays || {}).forEach(function (key) {
      const list = rawDays[key];
      if (!Array.isArray(list)) return;
      list.forEach(function (item) {
        const iso = typeof item === 'string' ? item : (item && (item.start || item.time));
        if (!iso) return;
        const day = melbourneDate(iso);
        if (!days[day]) days[day] = [];
        if (days[day].indexOf(iso) === -1) days[day].push(iso);
      });
    });
    Object.keys(days).forEach(function (day) {
      days[day].sort();
    });
    return days;
  }

  function firstAvailable(days) {
    const today = melbourneDate(new Date());
    const keys = Object.keys(days).sort();
    for (let i = 0; i < keys.length; i++) {
      if (keys[i] >= today && days[keys[i]].length) return keys[i];
    }
    return keys[0] || today;
  }

  function htmlEscape(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function track(eventName, params) {
    if (typeof window.mmTrack === 'function') window.mmTrack(eventName, params || {});
  }

  function Booker(root, options) {
    this.root = root;
    this.options = options || {};
    this.proxy = (options.proxy || DEFAULT_PROXY).replace(/\/$/, '');
    this.calLink = options.calLink || '';
    this.format = options.format || 'online';
    this.notes = options.notes || '';
    this.fallbackUrl = options.fallbackUrl || '';
    this.placement = options.placement || '';
    window.__mmCalBookerUid = (window.__mmCalBookerUid || 0) + 1;
    this.uid = 'mmcal' + window.__mmCalBookerUid;
    this.duration = splitCalLink(this.calLink).eventTypeSlug === 'melbourne-demo' ? 45 : 30;
    this.now = new Date();
    this.viewYear = this.now.getFullYear();
    this.viewMonth = this.now.getMonth();
    this.days = {};
    this.selectedDay = '';
    this.selectedStart = '';
    this.loading = false;
    this.root.classList.add('mm-cal-booker');
    this.renderShell();
    this.loadMonth();
  }

  Booker.prototype.renderShell = function () {
    this.root.innerHTML =
      '<div data-mm-cal-stage="pick">' +
        '<p class="mm-cal-booker__status" data-mm-cal-status>Loading available times…</p>' +
        '<div class="mm-cal-booker__grid" data-mm-cal-grid hidden>' +
          '<div>' +
            '<div class="mm-cal-booker__month">' +
              '<button type="button" class="mm-cal-booker__nav" data-mm-cal-prev aria-label="Previous month">' +
                '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M10 3L5 8l5 5"/></svg>' +
              '</button>' +
              '<p class="mm-cal-booker__month-label" data-mm-cal-month></p>' +
              '<button type="button" class="mm-cal-booker__nav" data-mm-cal-next aria-label="Next month">' +
                '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M6 3l5 5-5 5"/></svg>' +
              '</button>' +
            '</div>' +
            '<div class="mm-cal-booker__weekdays" aria-hidden="true"></div>' +
            '<div class="mm-cal-booker__days" data-mm-cal-days role="grid" aria-label="Available days"></div>' +
          '</div>' +
          '<div>' +
            '<div class="mm-cal-booker__slots-head">' +
              '<p class="mm-cal-booker__slots-label" data-mm-cal-slots-label>Pick a time</p>' +
              '<span class="mm-cal-booker__slots-meta">Melbourne time</span>' +
            '</div>' +
            '<div class="mm-cal-booker__slots" data-mm-cal-slots></div>' +
          '</div>' +
        '</div>' +
        '<form class="mm-cal-booker__details" data-mm-cal-form hidden autocomplete="off">' +
          '<p class="mm-cal-booker__summary" data-mm-cal-summary></p>' +
          '<p class="mm-cal-booker__error" data-mm-cal-form-error hidden></p>' +
          '<div class="mm-cal-booker__fields">' +
            '<div class="mm-cal-booker__field">' +
              '<label for="' + this.uid + '-name">Name</label>' +
              '<input id="' + this.uid + '-name" name="name" type="text" required' + PM_IGNORE + '>' +
            '</div>' +
            '<div class="mm-cal-booker__field">' +
              '<label for="' + this.uid + '-email">Email</label>' +
              '<input id="' + this.uid + '-email" name="email" type="email" required' + PM_IGNORE + '>' +
            '</div>' +
            '<div class="mm-cal-booker__field mm-cal-booker__field--full">' +
              '<label for="' + this.uid + '-phone">Mobile</label>' +
              '<input id="' + this.uid + '-phone" name="phone" type="tel"' + PM_IGNORE + '>' +
            '</div>' +
            '<div class="mm-cal-booker__field mm-cal-booker__field--full">' +
              '<label for="' + this.uid + '-notes">What do you need?</label>' +
              '<textarea id="' + this.uid + '-notes" name="notes" rows="3" placeholder="Site, dataset, workflow, or the kit you want to talk through"' + PM_IGNORE + '></textarea>' +
            '</div>' +
          '</div>' +
          '<button type="submit" class="mm-cal-booker__submit" data-mm-cal-submit>Book this time</button>' +
        '</form>' +
      '</div>' +
      '<div class="mm-cal-booker__done" data-mm-cal-stage="done" hidden>' +
        '<h3>You are booked</h3>' +
        '<p data-mm-cal-done-when></p>' +
        '<p>A calendar invite is on its way, with a Microsoft Teams link.</p>' +
      '</div>';

    const weekdays = $('.mm-cal-booker__weekdays', this.root);
    weekdays.innerHTML = WEEKDAYS.map(function (day) {
      return '<span class="mm-cal-booker__weekday">' + day + '</span>';
    }).join('');

    const form = $('[data-mm-cal-form]', this.root);
    const prefill = this.options.prefill || {};
    if (prefill.name) form.elements.name.value = prefill.name;
    if (prefill.email) form.elements.email.value = prefill.email;
    if (prefill.phone) form.elements.phone.value = prefill.phone;
    if (this.notes) form.elements.notes.value = this.notes;

    const self = this;
    this.root.addEventListener('click', function (e) {
      const prev = e.target.closest('[data-mm-cal-prev]');
      const next = e.target.closest('[data-mm-cal-next]');
      const dayBtn = e.target.closest('[data-mm-cal-day]');
      const slotBtn = e.target.closest('[data-mm-cal-slot]');
      if (prev) {
        e.preventDefault();
        self.shiftMonth(-1);
      } else if (next) {
        e.preventDefault();
        self.shiftMonth(1);
      } else if (dayBtn && dayBtn.getAttribute('data-available') === '1') {
        self.selectDay(dayBtn.getAttribute('data-mm-cal-day'));
      } else if (slotBtn) {
        self.selectSlot(slotBtn.getAttribute('data-mm-cal-slot'));
      }
    });
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      self.submit(form);
    });
  };

  Booker.prototype.setStatus = function (message, isError) {
    const status = $('[data-mm-cal-status]', this.root);
    const grid = $('[data-mm-cal-grid]', this.root);
    if (!message) {
      status.hidden = true;
      grid.hidden = false;
      return;
    }
    status.hidden = false;
    grid.hidden = isError;
    status.className = isError ? 'mm-cal-booker__error' : 'mm-cal-booker__status';
    if (isError && this.fallbackUrl) {
      status.innerHTML = htmlEscape(message) +
        ' <a class="mm-cal-booker__fallback" href="' + htmlEscape(this.fallbackUrl) + '" target="_blank" rel="noopener">Open the booking page</a>.';
    } else {
      status.textContent = message;
    }
  };

  Booker.prototype.shiftMonth = function (delta) {
    const next = new Date(this.viewYear, this.viewMonth + delta, 1);
    const now = new Date(this.now.getFullYear(), this.now.getMonth(), 1);
    if (next < now) return;
    this.viewYear = next.getFullYear();
    this.viewMonth = next.getMonth();
    this.loadMonth();
  };

  Booker.prototype.loadMonth = function () {
    const range = monthRange(this.viewYear, this.viewMonth);
    const parsed = splitCalLink(this.calLink);
    const params = new URLSearchParams({
      username: parsed.username,
      eventTypeSlug: parsed.eventTypeSlug,
      start: range.start,
      end: range.end
    });
    this.setStatus('Loading available times…');
    $('[data-mm-cal-form]', this.root).hidden = true;
    this.selectedStart = '';
    const self = this;
    fetch(this.proxy + '/cal-slots?' + params.toString())
      .then(function (res) {
        return res.text().then(function (text) {
          let json = {};
          try { json = text ? JSON.parse(text) : {}; } catch (err) { json = { ok: false, error: 'Could not load times' }; }
          return { res: res, json: json };
        });
      })
      .then(function (pack) {
        if (!pack.res.ok || pack.json.ok === false) {
          throw new Error(pack.json.error || 'Could not load times');
        }
        self.days = uniqueIsoStarts(pack.json.days || pack.json.data || {});
        self.selectedDay = firstAvailable(self.days);
        self.setStatus('');
        self.renderMonth();
      })
      .catch(function (err) {
        self.days = {};
        self.setStatus(err.message || 'Could not load times', true);
        self.renderMonth();
      });
  };

  Booker.prototype.renderMonth = function () {
    $('[data-mm-cal-month]', this.root).textContent = monthLabel(this.viewYear, this.viewMonth);
    const prev = $('[data-mm-cal-prev]', this.root);
    const nowMonth = new Date(this.now.getFullYear(), this.now.getMonth(), 1);
    prev.disabled = new Date(this.viewYear, this.viewMonth, 1) <= nowMonth;

    const today = melbourneDate(new Date());
    const startIndex = mondayIndex(this.viewYear, this.viewMonth);
    const total = daysInMonth(this.viewYear, this.viewMonth);
    const cells = [];
    for (let i = 0; i < startIndex; i++) cells.push({ empty: true });
    for (let day = 1; day <= total; day++) {
      const iso = this.viewYear + '-' + pad2(this.viewMonth + 1) + '-' + pad2(day);
      cells.push({
        iso: iso,
        label: String(day),
        available: Boolean(this.days[iso] && this.days[iso].length),
        today: iso === today
      });
    }
    $('[data-mm-cal-days]', this.root).innerHTML = cells.map(function (cell) {
      if (cell.empty) return '<span class="mm-cal-booker__day is-outside"></span>';
      const classes = ['mm-cal-booker__day'];
      if (cell.available) classes.push('is-available');
      if (cell.today) classes.push('is-today');
      if (cell.iso === this.selectedDay) classes.push('is-selected');
      return '<button type="button" class="' + classes.join(' ') +
        '" data-mm-cal-day="' + cell.iso +
        '" data-available="' + (cell.available ? '1' : '0') +
        '" ' + (cell.available ? '' : 'disabled') +
        ' aria-pressed="' + (cell.iso === this.selectedDay ? 'true' : 'false') +
        '">' + cell.label + '</button>';
    }, this).join('');
    this.renderSlots();
  };

  Booker.prototype.selectDay = function (iso) {
    this.selectedDay = iso;
    this.selectedStart = '';
    this.renderMonth();
  };

  Booker.prototype.renderSlots = function () {
    const slots = this.days[this.selectedDay] || [];
    const label = $('[data-mm-cal-slots-label]', this.root);
    const list = $('[data-mm-cal-slots]', this.root);
    label.textContent = this.selectedDay ? formatDayHeading(this.selectedDay) : 'Pick a time';
    if (!this.selectedDay) {
      list.innerHTML = '<p class="mm-cal-booker__empty">Choose a day with an available time.</p>';
      return;
    }
    if (!slots.length) {
      list.innerHTML = '<p class="mm-cal-booker__empty">No times this day.</p>';
      $('[data-mm-cal-form]', this.root).hidden = true;
      return;
    }
    list.innerHTML = slots.map(function (iso) {
      const selected = iso === this.selectedStart;
      return '<button type="button" class="mm-cal-booker__slot' + (selected ? ' is-selected' : '') +
        '" data-mm-cal-slot="' + htmlEscape(iso) +
        '" aria-pressed="' + (selected ? 'true' : 'false') +
        '">' + htmlEscape(formatTime(iso)) + '</button>';
    }, this).join('');
    if (!this.selectedStart) $('[data-mm-cal-form]', this.root).hidden = true;
  };

  Booker.prototype.selectSlot = function (iso) {
    this.selectedStart = iso;
    this.renderSlots();
    const form = $('[data-mm-cal-form]', this.root);
    form.hidden = false;
    $('[data-mm-cal-summary]', this.root).textContent = formatWhen(iso) + ' · Melbourne time · ' + this.duration + ' min';
    $('[data-mm-cal-form-error]', this.root).hidden = true;
    if (typeof form.scrollIntoView === 'function') form.scrollIntoView({ block: 'nearest' });
  };

  Booker.prototype.submit = function (form) {
    if (this.loading || !this.selectedStart) return;
    const parsed = splitCalLink(this.calLink);
    const payload = {
      username: parsed.username,
      eventTypeSlug: parsed.eventTypeSlug,
      start: this.selectedStart,
      name: form.elements.name.value.trim(),
      email: form.elements.email.value.trim(),
      phone: form.elements.phone.value.trim(),
      notes: form.elements.notes.value.trim(),
      source: window.location.pathname,
      cta_placement: this.placement,
      meeting_format: this.format,
      js: true
    };
    const errorEl = $('[data-mm-cal-form-error]', this.root);
    const submit = $('[data-mm-cal-submit]', this.root);
    this.loading = true;
    submit.disabled = true;
    submit.textContent = 'Booking…';
    errorEl.hidden = true;
    const self = this;
    fetch(this.proxy + '/cal-book', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (res) {
        return res.text().then(function (text) {
          let json = {};
          try { json = text ? JSON.parse(text) : {}; } catch (err) { json = { ok: false, error: 'Could not book that time' }; }
          return { res: res, json: json };
        });
      })
      .then(function (pack) {
        if (!pack.res.ok || pack.json.ok === false) {
          throw new Error(pack.json.error || 'Could not book that time');
        }
        self.showDone(pack.json);
      })
      .catch(function (err) {
        errorEl.hidden = false;
        errorEl.textContent = err.message || 'Could not book that time. Pick another slot.';
        self.loading = false;
        submit.disabled = false;
        submit.textContent = 'Book this time';
      });
  };

  Booker.prototype.showDone = function (result) {
    $('[data-mm-cal-stage="pick"]', this.root).hidden = true;
    const done = $('[data-mm-cal-stage="done"]', this.root);
    done.hidden = false;
    $('[data-mm-cal-done-when]', this.root).textContent = formatWhen(result.start || this.selectedStart);
    const params = {
      intent: 'demo',
      source: 'modal',
      demo_step: 'booked',
      meeting_format: this.format,
      cta_placement: this.placement || 'cal_booking'
    };
    track('demo_booking', params);
    track('demo_booked', params);
    if (typeof this.options.onBooked === 'function') this.options.onBooked(result);
  };

  function mount(container, options) {
    if (!container) return null;
    container.innerHTML = '';
    return new Booker(container, options || {});
  }

  function dialogFor(id) {
    return document.getElementById('mm-cal-dialog-' + id);
  }

  function picks(d) {
    return d.querySelectorAll('[data-mm-cal-pick]');
  }

  function showChooser(d) {
    const chooser = $('[data-mm-cal-chooser]', d);
    const booker = $('[data-mm-cal-booker]', d);
    const back = $('[data-mm-cal-back]', d);
    const heading = $('[data-mm-cal-heading]', d);
    const sub = $('[data-mm-cal-sub]', d);
    d.classList.remove('is-booking');
    if (chooser) chooser.hidden = false;
    if (booker) booker.hidden = true;
    if (back) back.hidden = true;
    if (heading) heading.textContent = d.getAttribute('data-mm-cal-default-heading') || 'Book a time';
    if (sub) sub.textContent = d.getAttribute('data-mm-cal-default-sub') || '';
    const mountEl = $('[data-mm-cal-mount]', d);
    if (mountEl) mountEl.innerHTML = '';
  }

  function mountFromPick(d, pick) {
    const format = pick.getAttribute('data-mm-cal-pick');
    const rawUrl = pick.getAttribute('data-mm-cal-url');
    const chooser = $('[data-mm-cal-chooser]', d);
    const booker = $('[data-mm-cal-booker]', d);
    const back = $('[data-mm-cal-back]', d);
    const heading = $('[data-mm-cal-heading]', d);
    const mountEl = $('[data-mm-cal-mount]', d);
    if (!rawUrl || !mountEl) return;

    d.classList.add('is-booking');
    if (chooser) chooser.hidden = true;
    if (booker) booker.hidden = false;
    if (back) back.hidden = picks(d).length < 2;
    if (heading) {
      heading.textContent = format === 'melbourne'
        ? 'Melbourne demo'
        : (d.getAttribute('data-mm-cal-online-title') || 'Talk through the job');
    }

    mount(mountEl, {
      proxy: d.getAttribute('data-mm-cal-proxy') || DEFAULT_PROXY,
      calLink: toCalLink(rawUrl),
      fallbackUrl: rawUrl,
      format: format,
      notes: (d.getAttribute('data-mm-cal-notes') || '').trim(),
      placement: d.getAttribute('data-mm-cal-placement') || 'cal_booking',
      prefill: {
        name: d.getAttribute('data-mm-cal-prefill-name') || '',
        email: d.getAttribute('data-mm-cal-prefill-email') || '',
        phone: d.getAttribute('data-mm-cal-prefill-phone') || ''
      }
    });
  }

  function openCal(id, trigger) {
    const d = dialogFor(id);
    if (!d) return;
    const headingOverride = trigger.getAttribute('data-mm-cal-title');
    const subOverride = trigger.getAttribute('data-mm-cal-subtitle');
    const contextOverride = trigger.getAttribute('data-mm-cal-context');
    const placement = trigger.getAttribute('data-mm-cta-placement') || '';
    const format = trigger.getAttribute('data-mm-cal-format');
    const heading = $('[data-mm-cal-heading]', d);
    const sub = $('[data-mm-cal-sub]', d);

    if (contextOverride) d.setAttribute('data-mm-cal-notes', contextOverride);
    d.setAttribute('data-mm-cal-placement', placement);
    showChooser(d);
    if (headingOverride && heading) heading.textContent = headingOverride;
    if (subOverride && sub) sub.textContent = subOverride;
    d.showModal();
    track('demo_booking', {
      intent: 'demo',
      source: 'modal',
      demo_step: 'open',
      cta_placement: placement || 'cal_booking'
    });

    const available = picks(d);
    if (available.length === 1) {
      available[0].click();
      return;
    }
    if (format === 'online' || format === 'melbourne') {
      const pick = d.querySelector('[data-mm-cal-pick="' + format + '"]');
      if (pick) pick.click();
    }
  }

  function bindDialog(d) {
    const id = d.getAttribute('data-mm-cal-shared');
    if (!id || d.getAttribute('data-mm-cal-bound') === '1') return;
    d.setAttribute('data-mm-cal-bound', '1');

    document.addEventListener('click', function (e) {
      const openBtn = e.target.closest('[data-mm-cal-open="' + id + '"]');
      if (openBtn) {
        e.preventDefault();
        openCal(id, openBtn);
        return;
      }
      if (!d.open) return;
      if (e.target === d || e.target.closest('[data-mm-cal-close="' + id + '"]')) {
        d.close();
        return;
      }
      const pick = e.target.closest('[data-mm-cal-pick]');
      if (pick && d.contains(pick)) {
        mountFromPick(d, pick);
        return;
      }
      const back = e.target.closest('[data-mm-cal-back]');
      if (back && d.contains(back)) showChooser(d);
    });
  }

  function bindAll() {
    document.querySelectorAll('dialog[data-mm-cal-shared]').forEach(bindDialog);
  }

  window.mmCalBooker = {
    mount: mount,
    toCalLink: toCalLink,
    bindAll: bindAll
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }
})();
